/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Sponsor / Advisor / Agent classification. Null for organizations that have never been classified. Only SPONSOR organizations can define Programme Defaults
 */
export enum OrganizationType {
    SPONSOR = 'SPONSOR',
    ADVISOR = 'ADVISOR',
    AGENT = 'AGENT',
}
